"use client";
import { TimePicker } from "antd";
import type { TimePickerProps } from "antd";

function AppTime(props: TimePickerProps) {
  return (
    <TimePicker
      style={{ width: "100%" }}
      format="HH:mm"
      {...props}
    />
  );
}

export { AppTime };
